
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>backup_table</mat-icon></span>
      Attach to {{placeholderNameForShow}}
    <button mat-icon-button (click)="closeAIAutomationTemplate()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>


  <div class="template-holder">
   
    <div class="right">

      <div class="list">

        <div class="tempalteList">
          <table cellspacing="0" cellspadding="0" width="100%">
            <tr>
              <th>File Name</th>             
              <th class="actBtn">Action</th>
            </tr>
            <tr *ngFor="let template of FilesNewList"       
              [ngClass]="{ 'active': template.fileManagerItemID === fileManagerID}"       
              [ngStyle]="{ 'background-color': template.fileManagerItemID === fileManagerID ? '#e8f0fe' : 'transparent' }">

              <td class="formName">
                <!-- PDF Icon -->
                <mat-icon style="vertical-align: middle; color:#d32f2f;">picture_as_pdf</mat-icon>
                <!-- File Name -->
                {{template.name}}
              </td>              
              <td>
                <button mat-stroked-button color="primary" (click)="SelectAITemplate(template)">Select</button>
              </td>
            </tr>
          </table>
          <div *ngIf="ShowNoRecordFound" class="noRecordFound">No Record Found</div>
        </div>

      </div>

    </div>
  </div>

  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="closeAIAutomationTemplate()">Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit" color="primary" *ngIf="fileManagerID!=0"
    (click)="attachFiles()">
      Attach
    </button>
  </mat-dialog-actions>


